// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"jZ","navPanel":"jZ","nav-panel-bg":"j0","navPanelBg":"j0","nav-panel-content":"j1","navPanelContent":"j1","none":"j2","block":"j3"};